import { useContext } from 'react';

import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { FeaturedBannerType } from '../../../types/FeaturedBanner';
import Api from '../../api/api';

export type CreateFeaturedBannerDTO = {
  object_id: string;
  type: FeaturedBannerType;
};

export const createFeaturedBanner = async (params: CreateFeaturedBannerDTO) => {
  const [response, bodyOrError] = await Api.post('featured-banner', params);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useCreateFeaturedBanner = () => {
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);
  return useMutation('createFeaturedBanner', createFeaturedBanner, {
    onSuccess: () => {
      setAlertSnackbar({
        message: 'FeaturedBanner created successfully',
        severity: 'success',
        vertical: 'top',
      });
      navigate('/cms/featured-banner');
    },
  });
};
